(function(window, document)
{
	"use strict";

	if (typeof(window.cdu) == "undefined") {
		window.cdu = {};
	}
	if (typeof(window.cdu.helpers) == "undefined")
	{
		var self = {};
		window.cdu.helpers = self;

    self.viewport = function() {
      var e = window
      , a = 'inner';
      if ( !( 'innerWidth' in window ) ) {
      a = 'client';
      e = document.documentElement || document.body;
      }
      return { width : e[ a+'Width' ] , height : e[ a+'Height' ] }
    };

    self.addListener = function(el, event, callback) {
			if (el != null) {
				el.addEventListener(event, callback);
			}
    };

    self.addClass = function(el, cls){
      if(!this.hasClass(el, cls)){
        el.className += (el.className.length == 0 ? cls : " " + cls);
      }
    };

    self.removeClass = function(el, cls){
      if(this.hasClass(el, cls)){
        el.className = el.className.replace((el.className.length == cls.length ? cls : " " + cls), "");
      }
    };

    self.hasClass = function(el, cls){
      return el.className.indexOf(cls) != -1;
    };

    self.swapClass = function(el, cls, cls2){
      if(self.hasClass(el, cls)){
        self.removeClass(el, cls);
        self.addClass(el, cls2);
      }else{
        self.addClass(el, cls2);
      }
    };

  }
})(window, document);

(function(window, document, helpers)
{
	"use strict";

	var self = {};

	

	self.init = function()
	{
		self.headerCheckboxesArr = document.getElementsByClassName('cwf-hdr-checkbox-flyout-menu');
    self.setupFeatureDetection();
    self.setupClickDetection(self.headerCheckboxesArr);
    self.setupSearchFunctionality();
		// self.setupMenuCloseDetection();
		self.setupHoverDetection();
		self.setupFlyoutAnimationFunctionality();
		self.flyoutFunctionality();
	};

// Phase 2 Development \/\/\/

	self.flyoutFunctionality = function(){

		var subNavs = document.getElementsByClassName('sublink');

		var subNavEvent = function(){
			var childUl = this.querySelector('.cwf-hdr-flyout-subcol').classList;
			var parentLink = this.querySelector('.sublink').classList;
			var active = document.getElementsByClassName('active');


			for(var i = 0; i < active.length; i++){
				active[i].classList.remove('active')
			};
			
			childUl.add('active');
			parentLink.add('active');

		}

		// Adding a fix for the double selection (Extra encouragement to remove active on mouseout)
		var subNavOutEvent = function(){
			var childUl = this.querySelector('.cwf-hdr-flyout-subcol').classList;
			var parentLink = this.querySelector('.sublink').classList;
			var active = document.getElementsByClassName('active');


			for(var i = 0; i < active.length; i++){
				active[i].classList.remove('active')
			};
		}

			for(var sublink in subNavs) {
				if(subNavs[sublink].parentElement != undefined){
					subNavs[sublink].parentElement.addEventListener('mouseout',subNavOutEvent);
					subNavs[sublink].parentElement.addEventListener('mouseover',subNavEvent);
				}
		};
	};

	// Phase 2 development ^^^

  self.setupFeatureDetection = function() {
    if (!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch)) {
        document.documentElement.className += " cdu-mouse";
    }
  };

  self.setupClickDetection = function(headerCheckboxesArr) {
    var detectOutsideFlyoutClickHandler = function(e) {
      if (helpers.viewport().width > 767) {
        var runCheck = true;

				if (headerCheckboxesArr.length > 0) {
					for (var i = 0; i < headerCheckboxesArr.length; i++) {
						if (e.target.parentNode == headerCheckboxesArr[i].parentNode || e.target.id == "cwf-hdr-checkbox-remove") {
	            runCheck = false;
	          }
	        }

	        if (runCheck && document.querySelector('input[name = "cwf-hdr-checkbox-flyout-group"]:checked') != null) {
	          var el = document.querySelector('input[name = "cwf-hdr-checkbox-flyout-group"]:checked').parentNode;

	          if (typeof el != 'undefined') {
	            var insideClick = false;

	            for (var element = e.target; element; element = element.parentNode) {
	              if (element == el) {
	                insideClick = true;
	                return;
	              }
	            }

	            if (insideClick == false) {
	              var removeCheck = document.getElementById('cwf-hdr-checkbox-remove');
	              removeCheck.checked = true;
	            }
	          }
	        }
				}
      }
    };

		var detectOutsideCountrySelectorClickHandler = function(e) {
			if (helpers.viewport().width > 767) {
				if (document.getElementById('cwf-hdr-country-dropdown') != null) {
	        var runCheck = true;

	        if (e.target.id == "cwf-hdr-country-dropdown" || e.target.id == "cwf-hdr-checkbox-country-selector") {
	          runCheck = false;
	        }

	        if (runCheck && document.getElementById('cwf-hdr-checkbox-country-selector').checked == true) {
	          var el = document.getElementById('cwf-hdr-country-selector-flyout');

	          if (typeof el != 'undefined') {
	            var insideClick = false;

	            for (var element = e.target; element; element = element.parentNode) {
	              if (element == el) {
	                insideClick = true;
	                return;
	              }
	            }

	            if (insideClick == false) {
	              var removeCheck = document.getElementById('cwf-hdr-checkbox-country-selector');
	              removeCheck.checked = false;
	            }
	          }
	        }
				}
      }
		};

		var detectOutsideSearchFlyoutClickHandler = function(e) {
			if (document.getElementById('cwf-hdr-search') != null) {
        var runCheck = true;

				if (e.target.id == "cwf-hdr-checkbox-menu-remove") {
					document.getElementById("cwf-hdr-search-input").blur();
				}

        if (e.target.id == "cwf-hdr-checkbox-menu-remove" || e.target.id == "cwf-hdr-checkbox-search") {
					runCheck = false;
        }

        if (runCheck && document.getElementById('cwf-hdr-checkbox-search').checked == true) {
          var el = document.getElementById('cwf-hdr-searchbox-flyout');

          if (typeof el != 'undefined') {
            var insideClick = false;

            for (var element = e.target; element; element = element.parentNode) {
              if (element == el) {
                insideClick = true;
                return;
              }
            }

            if (insideClick == false) {
              var removeCheck = document.getElementById('cwf-hdr-checkbox-menu-remove');
              removeCheck.checked = true;
							document.getElementById("cwf-hdr-search-input").blur();
            }
          }
        }
			}
		};

		helpers.addListener(document, 'click', detectOutsideSearchFlyoutClickHandler);
    helpers.addListener(document, 'click', detectOutsideCountrySelectorClickHandler);
    helpers.addListener(document, 'click', detectOutsideFlyoutClickHandler);
  };

	self.setupFlyoutAnimationFunctionality = function(){
		// Element Vars.
		var navContainer = document.querySelector(".cwf-hdr-nav-container");
		var flyoutOpen = document.querySelectorAll("input.cwf-hdr-checkbox-flyout-menu");
		var flyoutClose = document.querySelector("input#cwf-hdr-checkbox-remove");
		var menuRadioGroup = document.querySelectorAll("input[name='cwf-hdr-checkbox-flyout-menu-group']");

		// Handlers.
		var openFlyoutHandler = function(e) {
			if (helpers.viewport().width < 768) {
				helpers.removeClass(navContainer, "cwf-hdr-flyout-exit");
				helpers.swapClass(navContainer, "cwf-hdr-flyout-close", "cwf-hdr-flyout-open");
			}
		};

		var closeFlyoutHandler = function(e) {
			if (helpers.viewport().width < 768) {
				helpers.swapClass(navContainer, "cwf-hdr-flyout-open", "cwf-hdr-flyout-close");
			}
		};

		var menuRadioChangeHandler = function(e) {
			if (e.target.id !== "cwf-hdr-checkbox-menu-btn" && e.target.checked) {
				helpers.removeClass(navContainer, "cwf-hdr-flyout-open");
				helpers.removeClass(navContainer, "cwf-hdr-flyout-close");
				helpers.addClass(navContainer, "cwf-hdr-flyout-exit");
				flyoutClose.checked = true;
			}
			else {
+				helpers.removeClass(navContainer, "cwf-hdr-flyout-open");
+				helpers.removeClass(navContainer, "cwf-hdr-flyout-exit");
+				helpers.addClass(navContainer, "cwf-hdr-flyout-close");
 			}
		};

		// Events.
		for(var i = 0; i < flyoutOpen.length; i++){
			helpers.addListener(flyoutOpen[i], 'change', openFlyoutHandler);
		}

		helpers.addListener(flyoutClose, 'change', closeFlyoutHandler);

		for(var i = 0; i < menuRadioGroup.length; i++){
			helpers.addListener(menuRadioGroup[i], 'change', menuRadioChangeHandler);
		}
	};

  self.setupSearchFunctionality = function() {
    var searchboxFocusHandler = function(e) {
      var searchEl = document.getElementById("cwf-hdr-search-input");
      if (document.getElementById("cwf-hdr-checkbox-search").checked == true && typeof searchEl != 'undefined')
        document.getElementById("cwf-hdr-search-input").focus();
    };

    var clearSearchboxHandler = function(e) {
      var searchEl = document.getElementById("cwf-hdr-search-input");
      if (typeof searchEl != 'undefined') {
        searchEl.value = '';
        document.getElementById("cwf-hdr-search-input").focus();
      }
    };

    helpers.addListener(document.getElementById("cwf-hdr-checkbox-search"), 'click', searchboxFocusHandler);
    helpers.addListener(document.getElementById("cwf-hdr-checkbox-search"), 'touchend', searchboxFocusHandler);
    helpers.addListener(document.getElementById("cwf-hdr-search-clear"), 'click', clearSearchboxHandler);
    helpers.addListener(document.getElementById("cwf-hdr-search-clear"), 'touchend', clearSearchboxHandler);
  };

	self.setupMenuCloseDetection = function() {
		var resetMenuHandler = function(e) {
			if (helpers.viewport().width < 768) {
				if (e.target.checked == true) {
					var flyoutClose = document.getElementById("cwf-hdr-checkbox-remove");
					flyoutClose.checked = true;
				}
			}
		}
		helpers.addListener(document.getElementById("cwf-hdr-checkbox-menu-remove"), 'change', resetMenuHandler);
	};

	self.setupHoverDetection = function() {
		var closeSearchHandler = function(e) {
			var searchInput = document.getElementById('cwf-hdr-checkbox-search');
			if (typeof searchInput != 'undefined') {
				if (searchInput.checked == true) {
					//var removeCheck = document.getElementById('cwf-hdr-checkbox-menu-remove');
					//removeCheck.checked = true;
					document.getElementById("cwf-hdr-search-input").blur();
				}
			}
		};

		var checkSearchStatusHandler = function(e) {
			var searchInput = document.getElementById('cwf-hdr-checkbox-search');
			if (typeof searchInput != 'undefined') {
				if (searchInput.checked == true) {
					document.getElementById("cwf-hdr-search-input").focus();
				}
			}
		};
		helpers.addListener(document.getElementById("cwf-hdr-primary-nav-list"), 'mouseover', closeSearchHandler);
		helpers.addListener(document.getElementById("cwf-hdr-primary-nav-list"), 'mouseout', checkSearchStatusHandler);
	};

  self.init();

})(window, document, window.cdu.helpers);
